import React, { forwardRef } from "react";
import styled from "styled-components";

import { Color } from "../Color/Color";
import { Flex } from "../Box/Box";

const ScrollerElement = styled(Flex)<Props>`
  width: 100%;
  flex-direction: column;
  overflow-y: auto;
  min-height: 0;
  flex-grow: 1;
  max-height: ${({ maxHeight }) => maxHeight};
  scrollbar-gutter: ${({ gutter }) => gutter};

  scrollbar-color: ${Color.primary} ${Color.white};
  scrollbar-width: ${({ size }) => (size === "thin" ? "thin" : "auto")};
`;

interface Props {
  size?: "regular" | "thin";
  maxHeight?: string;
  children: React.ReactNode;
  gutter?: "auto" | "stable" | "stable both-edges";
}

export const Scroller = forwardRef<HTMLDivElement, Props>(
  ({ size = "thin", maxHeight, gutter = "stable", children }, ref) => (
    <ScrollerElement ref={ref} size={size} maxHeight={maxHeight} gutter={gutter}>
      {children}
    </ScrollerElement>
  ),
);
